import React from "react";
import imageCompression from "browser-image-compression";
import "./ImageUploader.scss";
import AttachmentUploader from "./AttachmentUploader";

const ImageUploader = ({ onUploadImageClick, existingImageCount = 0 }) => {
  const compressionOptions = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };

  const readFileAsync = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          resolve(file);
        },
        false,
      );

      reader.readAsDataURL(file);
    });
  };

  return (
    <AttachmentUploader
      onUploadImageClick={onUploadImageClick}
      existingImageCount={existingImageCount}
      accept="image/*,application/pdf"
      validateFileOnChange={(imageFile) => {
        if (
          imageFile.type.split("/")[0] === "image" ||
          imageFile.type === "application/pdf"
        ) {
          return readFileAsync(imageFile);
        } else {
          throw new Error("File must be an image.");
        }
      }}
      preprocessFilesBeforeSave={async (imageToSave) => {
        if (imageToSave.type === "application/pdf") {
          return imageToSave;
        } else {
          return await imageCompression(imageToSave, compressionOptions);
        }
      }}
      uploadSuccessMessage="Image upload successful!"
      uploadErrorMessage="There was a problem uploading this image."
      noFilesErrorMessage="No image selected."
    />
  );
};

export default ImageUploader;
